import { render, staticRenderFns } from "./PanePicker.vue?vue&type=template&id=4ad50201&scoped=true"
import script from "./PanePicker.vue?vue&type=script&lang=js"
export * from "./PanePicker.vue?vue&type=script&lang=js"
import style0 from "./PanePicker.vue?vue&type=style&index=0&id=4ad50201&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad50201",
  null
  
)

export default component.exports